import { render } from "./HeaderAudioPreview.vue?vue&type=template&id=0cc8ad00&scoped=true"
import script from "./HeaderAudioPreview.vue?vue&type=script&lang=js"
export * from "./HeaderAudioPreview.vue?vue&type=script&lang=js"

import "./HeaderAudioPreview.vue?vue&type=style&index=0&id=0cc8ad00&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc8ad00"]])

export default __exports__